import { useCallback } from 'react'

import useCvip from './useCvip'
import { useWallet } from 'use-wallet'

import { harvest, getMasterChefContract } from '../cvip/utils'

const useReward = (pid: number) => {
  const { account } = useWallet()
  const cvip = useCvip()
  const masterChefContract = getMasterChefContract(cvip)

  const handleReward = useCallback(async () => {
    const txHash = await harvest(masterChefContract, pid, account)
    console.log(txHash)
    return txHash
  }, [account, pid, cvip])

  return { onReward: handleReward }
}

export default useReward
